import { Component } from '@angular/core'
import { LogoTheme } from '../../types'
import { FooterHelpLinksComponent } from '../footer-help-links'
import { FtrLogoComponent } from '../ftr-logo'

@Component({
  selector: 'ftr-footer-logged-out',
  templateUrl: './footer-logged-out.component.html',
  styleUrls: ['./footer-logged-out.component.css'],
  imports: [FtrLogoComponent, FooterHelpLinksComponent],
})
export class FooterLoggedOutComponent {
  readonly logoThemes = LogoTheme
}
